export const PUBLIC_MARKETING_COOKIE_CONSENT_KEY =
  "tkl_external_catalog_cookie_consent";

/** Fired on `window` after consent is saved (same tab). */
export const PUBLIC_MARKETING_COOKIES_ACCEPTED_EVENT =
  "tkl-public-marketing-cookies-accepted";

export function readPublicMarketingCookieConsent(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return (
      window.localStorage.getItem(PUBLIC_MARKETING_COOKIE_CONSENT_KEY) ===
      "accepted"
    );
  } catch {
    return false;
  }
}
